function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "19.8232627%",
  y1: "65.8067294%",
  x2: "124.189238%",
  y2: "65.8067294%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF9A6B",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF7E80",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mensagem_tipo-de-resposta",
  transform: "translate(-265.000000, -190.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(265.000000, 190.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Illustrations-/-States-/-Notification",
  fill: "#EBEAF9"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 69.6000028,
  cy: 69.6000028,
  r: 69.6000028
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-22",
  transform: "translate(76.000000, 80.500000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-19",
  transform: "translate(0.379994, 0.105474)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Clip-18",
  points: "0.885740036 0.236691451 41.4895874 0.236691451 41.4895874 41.2799963 0.885740036 41.2799963"
})))), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#320056",
  cx: 69.5,
  cy: 84,
  r: 5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#320056",
  x: 64.5,
  y: 46,
  width: 10,
  height: 29,
  rx: 5
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.239063,85.1001796 L83.2020737,25.4248141 C80.2407382,20.799035 75.1218726,18 69.6235993,18 C64.125326,18 59.0064605,20.799035 56.0451249,25.4248141 L20.0081357,85.1001796 C17.4171655,89.4127903 17.3276102,94.7781292 19.773214,99.1745582 C22.6015474,104.124695 27.8790925,107.171807 33.5866101,107.150039 L105.660588,107.150039 C111.329269,107.210439 116.597751,104.240134 119.473985,99.3622166 C121.992749,94.9177071 121.902844,89.4595764 119.239063,85.1001796 L119.239063,85.1001796 Z M69.6235993,88.3842013 C67.0287258,88.3842013 64.9251653,86.2837633 64.9251653,83.6927417 C64.9251653,81.1017202 67.0287258,79.0012822 69.6235993,79.0012822 C72.2184728,79.0012822 74.3220334,81.1017202 74.3220334,83.6927417 C74.3220334,86.2837633 72.2184728,88.3842013 69.6235993,88.3842013 Z M74.3220334,69.6183631 C74.3220334,72.2093846 72.2184728,74.3098226 69.6235993,74.3098226 C67.0287258,74.3098226 64.9251653,72.2093846 64.9251653,69.6183631 L64.9251653,50.8525248 C64.9251653,48.2615033 67.0287258,46.1610653 69.6235993,46.1610653 C72.2184728,46.1610653 74.3220334,48.2615033 74.3220334,50.8525248 L74.3220334,69.6183631 Z",
  id: "Shape",
  fill: "url(#linearGradient-1)"
}))));

var SvgAlert = function SvgAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140px",
    height: "140px",
    viewBox: "0 0 140 140",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert.2026fe04.svg";
export { ForwardRef as ReactComponent };